import AuthRedirect from './AuthRedirect';

export default AuthRedirect;
